import { render, staticRenderFns } from "./WhatsNewPanel.vue?vue&type=template&id=3c4ab936&scoped=true"
import script from "./WhatsNewPanel.vue?vue&type=script&lang=js"
export * from "./WhatsNewPanel.vue?vue&type=script&lang=js"
import style0 from "./WhatsNewPanel.vue?vue&type=style&index=0&id=3c4ab936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4ab936",
  null
  
)

export default component.exports